module.exports = __webpack_public_path__ + "assets/Video2.91f945b1.svg";